/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.96"
        height="94.33"
        viewBox="0 0 83.96 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M42.82 26.21v2.5H30.48v65.62h-2.5V26.21ZM24.6 51.26v2.5h-8.11v40.57h-2.5V51.26ZM10.64 76.31v2.5H2.5v15.52H0v-18Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M66.7 82.94v11.39h-2.53V82.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M65.5 59.58a1.23 1.23 0 0 1 1.24 1.12v22.23a1.25 1.25 0 0 1-2.49.13V60.83a1.25 1.25 0 0 1 1.25-1.25ZM57.31 82.94v11.39h-2.5V82.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M56.06 38.25a1.25 1.25 0 0 1 1.24 1.12v43.57a1.25 1.25 0 0 1-1.25 1.25 1.27 1.27 0 0 1-1.25-1.13V39.5a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M72.57 22.82a11.4 11.4 0 0 1 11.39 11.11V58.5a3.89 3.89 0 0 1-3.68 3.68h-5.43a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31h5.35a1.39 1.39 0 0 0 1.43-1.3V34.22a8.91 8.91 0 0 0-8.64-8.89H58.33a8.91 8.91 0 0 0-8.89 8.64v24.28a1.39 1.39 0 0 0 1.25 1.38h5.37a1.25 1.25 0 0 1 .12 2.49h-5.35a3.89 3.89 0 0 1-3.89-3.62V34.22a11.39 11.39 0 0 1 11.1-11.39h14.53Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M74.85 82.94v11.39"/>
        <path
          fill="#fff"
          d="M76.1 82.94v11.39h-2.5V82.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M74.85 39.5v43.44"/>
        <path
          fill="#fff"
          d="M74.85 38.25a1.25 1.25 0 0 1 1.24 1.12v43.57a1.25 1.25 0 0 1-1.25 1.25 1.27 1.27 0 0 1-1.25-1.13V39.5a1.25 1.25 0 0 1 1.25-1.25ZM65.5 0a9.83 9.83 0 1 0 9.82 9.84A9.83 9.83 0 0 0 65.5 0Zm0 2.5a7.33 7.33 0 1 1-7.33 7.33A7.33 7.33 0 0 1 65.5 2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithPastGrowthHeightLinesIcon';

export default Icon;
